import { useExperienceModuleContext } from 'modules/experience-core';
import { ExperienceEntityType, NavigationItem } from 'modules/experience-core';

import {
  BEST_OF_WOLT_NAVIGATION_ITEM,
  BUSINESS_DETAILS_NAVIGATION_ITEM,
  CAMPAIGNS_NAVIGATION_ITEM,
  PURCHASES_NAVIGATION_ITEM,
  TRANSLATION_NAVIGATION_ITEM,
} from '../constants';

export const useVenueNavigationItems = (): NavigationItem[] => {
  const {
    experienceEntity: { experienceEntityType },
  } = useExperienceModuleContext();

  // TODO: Begin: Implement logic to determine if best of wolt navigation should be shown
  const shouldShowBestOfWoltNavigation = true;
  const shouldShowBusinessDetailsNavigation = true;
  const shouldShowPurchaseNavigation = true;
  const shouldShowTranslationNavigation = true;
  const shouldShowCampaignNavigation = experienceEntityType === ExperienceEntityType.VENUE;

  // TODO: End: Implement logic to determine if best of wolt navigation should be shown

  const campaignsNavigationItem = {
    ...CAMPAIGNS_NAVIGATION_ITEM,
    isVenueSpecific: true,
  };

  return [
    ...(shouldShowBestOfWoltNavigation ? [BEST_OF_WOLT_NAVIGATION_ITEM] : []),
    ...(shouldShowBusinessDetailsNavigation ? [BUSINESS_DETAILS_NAVIGATION_ITEM] : []),
    ...(shouldShowPurchaseNavigation ? [PURCHASES_NAVIGATION_ITEM] : []),
    ...(shouldShowTranslationNavigation ? [TRANSLATION_NAVIGATION_ITEM] : []),
    ...(shouldShowCampaignNavigation ? [campaignsNavigationItem] : []),
  ];
};
